import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { AccommodationContactUsersQuery } from './__generated__/form_user_query'
import { Query } from './form_user_query'
import { AccommodationContactAttributes } from '@/types'

interface Props {
  attributes: AccommodationContactAttributes
  setAttributes: React.Dispatch<React.SetStateAction<AccommodationContactAttributes>>
}

export const useUserContact = ({ attributes, setAttributes }: Props) => {
  const [pickedUser, setPickedUser] = useState(false)
  const { data } = useQuery<AccommodationContactUsersQuery>(Query, { variables: { userId: attributes.userId } })

  useEffect(() => {
    if (attributes.userId) {
      setPickedUser(true)
    } else {
      setPickedUser(false)
    }
  }, [attributes])

  useEffect(() => {
    if (data && pickedUser) {
      const user = data.users.nodes[0]

      setAttributes({ ...attributes, name: user.displayName, email: user.email, phone: user.phone || '' })
    }
  }, [attributes, setAttributes, data, pickedUser])

  return { pickedUser }
}
